import {defineStore} from 'pinia'
import axios from '@/api/axios'
import {AUTH_TOKEN_KEY, IMPERSONATION_TOKEN_KEY} from '@shared/constants/auth'

export const useAuthenticationStore = defineStore('authenticationStore', {
  state: () => ({
    isAuthenticated: false,
    user: {},
  }),
  getters: {
    authUser: state => {
      return state.user
    },
  },
  actions: {
    setToken: async function (token) {
      localStorage.setItem(AUTH_TOKEN_KEY, token)

      await this.setUserIsAuthenticated(!!token)
    },
    getAuthToken: function () {
      return sessionStorage.getItem(IMPERSONATION_TOKEN_KEY) || localStorage.getItem(AUTH_TOKEN_KEY)
    },
    async login(payload) {
      const {data} = await axios.post('/oauth/authorize', payload)

      return data
    },
    setUserIsAuthenticated: async function (payload) {
      this.isAuthenticated = payload
    },
    sendForgotPasswordRequest: async function (payload) {
      const {data} = await axios.post('auth/forgot-password', payload)

      return data
    },
    sendResetPasswordRequest: async function (payload) {
      const {data} = await axios.post('auth/reset-password', payload)

      return data
    },
    requestMagicLink: async function (payload) {
      const {data} = await axios.post('auth/magic-link', payload)

      return data
    },
    checkMagicLink: async function (token) {
      const {data} = await axios.get('auth/magic-link/check', {params: {token}})

      return data
    },
    consumeMagicLink: async function (token) {
      const {data} = await axios.post('auth/magic-link/consume', {token})

      return data
    },
    checkInvitation: async function (token) {
      const {data} = await axios.get('auth/invitation/check', {params: {token}})

      return data
    },
    acceptInvitation: async function (token) {
      const {data} = await axios.post('auth/invitation/accept', {token})

      return data
    },
  },
})
